"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainMenuItem = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _ListItemText = _interopRequireDefault(require("@eig-builder/core-ui/ListItemText"));

var _ListItemIcon = _interopRequireDefault(require("@eig-builder/core-ui/ListItemIcon"));

var _styles = require("@material-ui/core/styles");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var NestedMenuItem = (0, _styledComponents["default"])(function (_ref) {
  var nested = _ref.nested,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["nested"]);
  return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], props);
})(_templateObject(), function (props) {
  return props.nested ? "padding-left: ".concat(props.theme.spacing(14), "px !important;") : '';
});
var StyledListItemIcon = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      minWidth: 'initial',
      paddingRight: theme.spacing(4)
    }
  };
})(_ListItemIcon["default"]);

var MainMenuItem = function MainMenuItem(_ref2) {
  var hasSubItems = _ref2.hasSubItems,
      basePath = _ref2.basePath,
      active = _ref2.active,
      linkToIcon = _ref2.linkToIcon,
      materialIconTag = _ref2.materialIconTag,
      open = _ref2.open,
      title = _ref2.title,
      onClick = _ref2.onClick,
      onIconClick = _ref2.onIconClick,
      onToggleExpandClick = _ref2.onToggleExpandClick,
      nested = _ref2.nested,
      classes = _ref2.classes;
  return /*#__PURE__*/_react["default"].createElement(NestedMenuItem, {
    selected: hasSubItems ? active && active.isExact : basePath ? window.location.pathname.startsWith(basePath) : active && active.isExact,
    onClick: onClick,
    nested: nested,
    className: classes
  }, materialIconTag !== 'no-icon' && /*#__PURE__*/_react["default"].createElement(StyledListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    onClick: onIconClick
  }, materialIconTag), linkToIcon ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "link-icon"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: linkToIcon
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: linkToIcon === '' ? 'link-icon' : 'hidden'
  }))), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    primary: title
  }), hasSubItems ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    onClick: onToggleExpandClick
  }, open ? /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], null) : /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)) : null);
};

exports.MainMenuItem = MainMenuItem;
MainMenuItem.propTypes = {
  hasSubItems: _propTypes["default"].bool,
  basePath: _propTypes["default"].string,
  active: _propTypes["default"].object,
  linkToIcon: _propTypes["default"].string,
  materialIconTag: _propTypes["default"].string,
  open: _propTypes["default"].bool,
  title: _propTypes["default"].node,
  onClick: _propTypes["default"].func.isRequired,
  onIconClick: _propTypes["default"].func.isRequired,
  onToggleExpandClick: _propTypes["default"].func.isRequired,
  nested: _propTypes["default"].bool,
  classes: _propTypes["default"].string
};